module.exports = __webpack_public_path__ + "img/TV_clean_box25.ae35ba6b.jpg";